import React, {useEffect, useState} from "react";
import {Button, Checkbox, DialogActions, DialogContent, FormControlLabel} from "@mui/material";
import {useTranslation} from "react-i18next";
import CustomDialog from "../custom-dialog";
import CustomDialogTitle from "../custom-dialog-title";

const SettingsDialog = ({isSettingsVisible, setSettingsVisibility, tableSettings, setChartSettings}) => {
  const {t} = useTranslation();

  const [settings, setSettings] = useState(null);

  useEffect(() => {
    setSettings(tableSettings);
  }, [tableSettings]);

  const handleSettingsDialogClose = () => setSettingsVisibility(false);

  const handleSettingsDialogSubmit = () => {
    setChartSettings(settings);
    handleSettingsDialogClose();
  };

  return (
    <CustomDialog id="flat-table__settings_dialog" open={isSettingsVisible} onClose={handleSettingsDialogClose}>
      <CustomDialogTitle onClose={handleSettingsDialogClose}>
        {t("modules.flatTable.dialogs.settings.title")}
      </CustomDialogTitle>
      <DialogContent>
        <FormControlLabel
          control={
            <Checkbox
              checked={settings?.isTableMultiline || false}
              onChange={e => setSettings(settings => ({...settings, isTableMultiline: e.target.checked}))}
            />
          }
          label={t("modules.flatTable.dialogs.settings.fields.isTableMultiline.label")}
        />
      </DialogContent>
      <DialogActions>
        <Button id="flat-table__settings_dialog__cancel-btn" onClick={handleSettingsDialogClose}>
          {t("commons.confirm.cancel")}
        </Button>
        <Button id="flat-table__settings_dialog__apply-btn" color="primary" onClick={handleSettingsDialogSubmit}>
          {t("commons.confirm.apply")}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default SettingsDialog;
